var _style, _polygon, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSearchBlack = function SvgSearchBlack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 465 456",
    style: {
      enableBackground: "new 0 0 465 456"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#111111;stroke-width:14;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\r\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "418.9,379.3 386.2,412 302.2,328.1 335.5,295.9 418.9,379.3 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M219.5,73.6c76.8,0,139.1,62.3,139.1,139.1c0,76.8-62.3,139.1-139.1,139.1c-76.8,0-139.1-62.3-139.1-139.1 C80.4,135.9,142.7,73.6,219.5,73.6L219.5,73.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M218.2,113c55.6,0,100.7,45.1,100.7,100.7"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearchBlack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search-black.8683c5a4.svg";
export { ForwardRef as ReactComponent };